import { useState } from 'react';
import RadioInput from 'src/Admin/components/common/radio';
import Skeleton from 'src/Admin/components/common/skeleton';
import {
  DoctorProviderIconSVG,
  FacilityProviderIconSVG,
} from '../../../img/uploadDocument/uploadDocumentSVG';

const DataList = ({
  data,
  rightValueForLocationDisplayID = null,
  displayId = 'BlkOfBusId',
  displayLabel = 'BlkOfBusName',
  labelIdText,
  searchString,
  setDocTypeData,
  hasDescriptionText = false,
  skeletonLoader,
  docType,
  isServerError,
  physicianType,
  getMaskedSsn,
}) => {
  const onChangeHandler = (e) => {
    const { id } = e.target;
    console.log('e.target', id);
    const tempBlob = data?.map((blob) =>
      blob[displayId] === id
        ? { ...blob, isChecked: true }
        : { ...blob, isChecked: false },
    );
    console.log('tempBlob', tempBlob);
    setDocTypeData(tempBlob);
  };

  const [isNoDataError] = useState(false);

  return (
    <div>
      <div className="reports-modal-devider" />

      {![
        'PHYSICIAN',
        'CONNECTOR',
        'FACILITY',
        'BROKER',
        'CLAIM',
        'EMPLOYEE',
        'DEPENDENT',
      ].includes(docType.value) ? (
        <div className="blob-lists nonphysician">
          {!skeletonLoader && !(isServerError || isNoDataError) ? (
            data
              ?.filter((d) => {
                if (!searchString) return true;
                if (displayLabel !== '' && displayId !== '') {
                  if (
                    d[displayLabel]
                      ?.toLowerCase()
                      ?.includes(searchString?.toLowerCase()) ||
                    d[displayId]
                      ?.toLowerCase()
                      ?.includes(searchString?.toLowerCase())
                  ) {
                    return true;
                  }
                }
                return;
              })
              ?.map((item, index) => (
                <div key={index}>
                  <div className="blob-list-item-border" key={index}>
                    <div className="d-flex justify-content-between blob-list-item">
                      <div className="">
                        <RadioInput
                          onChange={onChangeHandler}
                          label={item[displayLabel]}
                          name={'Selected-Blob'}
                          value={item[displayId]}
                          id={item[displayId]}
                          checked={item?.isChecked || false}
                          className="cursor-pointer"
                        />
                      </div>
                      {labelIdText && (
                        <div className="blob-item-name-2">
                          {labelIdText}:{' '}
                          {item[rightValueForLocationDisplayID || displayId]}
                        </div>
                      )}
                    </div>
                    {hasDescriptionText && item?.LocationDescription && (
                      <div className="blob-item-desc">
                        {item?.LocationDescription}
                      </div>
                    )}
                  </div>
                </div>
              ))
          ) : isServerError || isNoDataError ? (
            <div>No Records Found</div>
          ) : (
            <Skeleton count={15} height={30} />
          )}
        </div>
      ) : docType.value === 'PHYSICIAN' ||
        docType.value === 'CONNECTOR' ||
        docType.value === 'FACILITY' ? (
        <div className="blob-lists physician">
          {!skeletonLoader && !(isServerError || !data.length) ? (
            data?.map((item, index) => (
              <div className="physician-list-item" key={index}>
                <div className="blob-list-item-border">
                  <div className="d-flex broker-list-item">
                    <div className="d-flex align-items-center">
                      <div className="d-flex mb-3">
                        <RadioInput
                          type="checkbox"
                          id={
                            physicianType === 'D'
                              ? item.PhysicainOid
                              : item.FacilityOID
                          }
                          name={
                            physicianType === 'D'
                              ? item.PhysicainOid
                              : item.FacilityOID
                          }
                          className="p-0 mt-auto mb-auto"
                          onChange={onChangeHandler}
                          checked={item?.isChecked || false}
                        />
                      </div>
                      <div className="facility-icon-div pl-2">
                        <div className="facility-icon">
                          {physicianType === 'D' ? (
                            <DoctorProviderIconSVG className="document_providericonsvg" />
                          ) : (
                            <FacilityProviderIconSVG className="document_providericonsvg" />
                          )}
                        </div>
                      </div>
                      <div>
                        <div>
                          <span className="blob-item-name-1">
                            {physicianType === 'D'
                              ? `${item.LastName}, ${item.FirstName} ${item.MiddleName}`
                              : item.FacilityName}
                          </span>
                        </div>
                        <div className="blob-item-desc-1">
                          {physicianType === 'D'
                            ? item.Specialty
                            : item.Address[0].address1 +
                              ',' +
                              item.Address[0].city +
                              ',' +
                              item.Address[0].state_prov +
                              ',' +
                              item.Address[0].postalCode}
                        </div>
                      </div>
                    </div>
                    <div>
                      {item.NationalProviderId && (
                        <div className="blob-item-desc-3">
                          NPI: {item.NationalProviderId}
                        </div>
                      )}
                      {item.TaxId && (
                        <div className="blob-item-desc-3">
                          Tax ID: {item.TaxId}
                        </div>
                      )}
                      {item.TaxID && (
                        <div className="blob-item-desc-3">
                          Tax ID: {item.TaxID}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : skeletonLoader ? (
            <Skeleton count={15} height={30} />
          ) : (isServerError || !data.length) && searchString.length ? (
            <div>No Records Found</div>
          ) : (
            ''
          )}
        </div>
      ) : docType.value === 'CLAIM' ||
        docType.value === 'EMPLOYEE' ||
        docType.value === 'DEPENDENT' ? (
        <div className="blob-lists physician">
          {!skeletonLoader && !(isServerError || !data.length) ? (
            data?.map((item, index) => (
              <div className="physician-list-item" key={index}>
                <div className="blob-list-item-border">
                  <div className="d-flex broker-list-item">
                    <div className="d-flex align-items-center">
                      <div className="d-flex mb-3">
                        <RadioInput
                          type="checkbox"
                          id={item?.OID}
                          name={item?.OID}
                          className="p-0 mt-auto mb-auto"
                          onChange={onChangeHandler}
                          checked={item?.isChecked || false}
                        />
                      </div>
                      <div>
                        <div>
                          <span className="blob-item-name-1">
                            {item?.FirstName + ' ' + item?.LastName}
                          </span>
                        </div>
                        <div className="blob-item-desc-1">
                          User type: {item?.MemberType}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        {item.memberID && (
                          <div className="blob-item-desc-3">
                            Member ID: {item.memberID}
                          </div>
                        )}
                      </div>
                      <div>
                        {getMaskedSsn(item?.SSN || '') && (
                          <div className="blob-item-desc-3">
                            SSN: {getMaskedSsn(item.SSN || '')}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : skeletonLoader ? (
            <Skeleton count={15} height={30} />
          ) : (isServerError || !data.length) && searchString.length ? (
            <div>No Records Found</div>
          ) : (
            ''
          )}
        </div>
      ) : (
        <div className="blob-lists physician">
          {!skeletonLoader && !(isServerError || !data.length) ? (
            data
              ?.filter((d) => {
                if (!searchString) return true;
                if (displayLabel !== '' && displayId !== '') {
                  if (
                    d[displayLabel]
                      ?.toLowerCase()
                      ?.includes(searchString?.toLowerCase()) ||
                    d[displayId]
                      ?.toLowerCase()
                      ?.includes(searchString?.toLowerCase())
                  ) {
                    return true;
                  }
                }
                return;
              })
              ?.map((item, index) => (
                <div className="physician-list-item" key={index}>
                  <div className="blob-list-item-border">
                    <div className="d-flex broker-list-item">
                      <div className="d-flex align-items-center">
                        <div className="d-flex mb-3">
                          <RadioInput
                            type="checkbox"
                            id={item.Code}
                            name={item.Code}
                            className="p-0 mt-auto mb-auto"
                            onChange={onChangeHandler}
                            checked={item?.isChecked || false}
                          />
                        </div>
                        <div className="pl-2">
                          <div>
                            <span className="blob-item-name-1">
                              {item.BrokerName}
                            </span>
                          </div>
                          <div className="blob-item-desc-1">
                            Type: {item.BrokerTypeDesc}{' '}
                            {item.Parent && `| Parent : ${item.Parent}`}
                          </div>
                        </div>
                      </div>
                      <div>
                        {item.Code && (
                          <div className="blob-item-desc-3">
                            ID: {item.Code}
                          </div>
                        )}
                        {item.TaxID && (
                          <div className="blob-item-desc-3">
                            Tax ID: {item.TaxID}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
          ) : skeletonLoader ? (
            <Skeleton count={15} height={30} />
          ) : (isServerError || !data.length) && searchString.length ? (
            <div>No Records Found</div>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};

export default DataList;
